import type { configuracaoSite } from "../types/widget.props"
import type { NewsletterForm } from "../components/Form"
import { ZordUtil } from "@/utils/Zord"

export async function submitNewsletter(form: NewsletterForm, config: configuracaoSite, hasFieldTelefone?: boolean) {
    if (!form.email || !Zord.Util.validator.emailValido(form.email)) {
        throw new Error("E-mail inválido")
    }

    if (config.newsletterExibeNome && (!form.nome || form.nome.length < 3)) {
        throw new Error("Nome inválido")
    }

    if (hasFieldTelefone && config.newsletterExibeTelefone && form.telefone) {
        if (!ZordUtil.contatoValido(form.telefone)) {
            throw new Error("Telefone inválido")
        }
    }

    const params = new URLSearchParams()
    
    if (form.nome) params.append("nome", form.nome)
    if (form.email) params.append("email", form.email)
    if (hasFieldTelefone && form.telefone) params.append("telefone", form.telefone)

    const response = await fetch("/cliente?operation=addNewsletter", {
        method: "POST",
        body: params,
    })
    
    const data = await response.json()

    if (data.status !== "success") {
        throw new Error(data.message || "Erro ao cadastrar.")
    }

    return data
}